var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"top-banner"},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('div',{staticClass:"user",on:{"click":_vm.logout}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }